/**
 * Which features are open only because of the Pro trial (#2816, «Показ
 * пробы») — the menu, the command palette and the dashboard tabs mark them
 * «Pro · trial» instead of a lock: open, and the customer learns it is the
 * trial that opened them.
 *
 * A feature is marked when the trial runs, the trial opens it (sold from a
 * tier above Free, up to Pro — `trialOpensFeature`) and its verdict is
 * `enabled`. A feature switched off by an administrator stays as the menu
 * already shows it.
 */
import { useCallback } from 'react';
import type { FeatureFlagKey } from '@aica/core';
import { useFeatureFlagsSafe } from '@/contexts/FeatureFlagsContext';
import { trialOpensFeature } from '@/lib/pro-trial';

export function useTrialOpened(): (flag: FeatureFlagKey) => boolean {
  const { proTrial, gate } = useFeatureFlagsSafe();
  const running = proTrial?.state === 'active';
  return useCallback(
    (flag) => running && trialOpensFeature(flag) && gate(flag) === 'enabled',
    [running, gate]
  );
}
